import React from 'react';
import { exportElement } from '../../utils/exportElement';

export default function ExportButtons({ targetRef, filename = 'export', data = [] }) {
  if (!targetRef) return null;

  // Don't show buttons if no data
  if (!Array.isArray(data) || data.length === 0) return null;

  return (
    <div className='export-btn-chart justify-content-end' style={{ margin: '20px  0', display: 'flex', gap: 10 }}>
      <button className='buttons background-button' onClick={() => exportElement(targetRef.current, 'image', filename)}>
        Export as Image
      </button>
      <button className='buttons background-button' onClick={() => exportElement(targetRef.current, 'pdf', filename)}>
        Export as PDF
      </button>
    </div>
  );
}
